export function toBoolean(value) {
  return value === "true" || value === true;
}
